var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCaffeeActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 5.12012C6.09 5.12012 5.75 4.78012 5.75 4.37012V2.62012C5.75 2.21012 6.09 1.87012 6.5 1.87012C6.91 1.87012 7.25 2.21012 7.25 2.62012V4.37012C7.25 4.79012 6.91 5.12012 6.5 5.12012Z",
    fill: "url(#paint0_linear_1721_53248)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 5.12012C10.09 5.12012 9.75 4.78012 9.75 4.37012V2.62012C9.75 2.21012 10.09 1.87012 10.5 1.87012C10.91 1.87012 11.25 2.21012 11.25 2.62012V4.37012C11.25 4.79012 10.91 5.12012 10.5 5.12012Z",
    fill: "url(#paint1_linear_1721_53248)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 5.12012C14.09 5.12012 13.75 4.78012 13.75 4.37012V2.62012C13.75 2.21012 14.09 1.87012 14.5 1.87012C14.91 1.87012 15.25 2.21012 15.25 2.62012V4.37012C15.25 4.79012 14.91 5.12012 14.5 5.12012Z",
    fill: "url(#paint2_linear_1721_53248)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.75 13.2498C22.75 10.6298 20.72 8.50977 18.16 8.28977C17.42 7.07977 16.1 6.25977 14.58 6.25977H7.21C4.89 6.25977 3 8.14977 3 10.4698V10.9998H18.79V10.4698C18.79 10.2798 18.76 10.0898 18.73 9.90977C20.18 10.3398 21.25 11.6598 21.25 13.2498C21.25 14.8198 20.21 16.1298 18.79 16.5698V11.9998H3V17.7898C3 20.1098 4.89 21.9998 7.21 21.9998H14.58C16.78 21.9998 18.57 20.2998 18.75 18.1398C21.03 17.6798 22.75 15.6598 22.75 13.2498Z",
    fill: "url(#paint3_linear_1721_53248)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1721_53248",
    x1: 6.5,
    y1: 1.87012,
    x2: 6.5,
    y2: 5.12012,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A79D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6EC282"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1721_53248",
    x1: 10.5,
    y1: 1.87012,
    x2: 10.5,
    y2: 5.12012,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A79D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6EC282"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1721_53248",
    x1: 14.5,
    y1: 1.87012,
    x2: 14.5,
    y2: 5.12012,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A79D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6EC282"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1721_53248",
    x1: 12.875,
    y1: 6.25977,
    x2: 12.875,
    y2: 21.9998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A79D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6EC282"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaffeeActive);
export default __webpack_public_path__ + "static/media/caffee-active.27b2e2ec5d59ef889d7ab63feb56be26.svg";
export { ForwardRef as ReactComponent };